export const getTypeVehiclesService = (fetch) => async (filters) => {
  try {
    const searchParams = new URLSearchParams(filters).toString();
    const response = await fetch({
      url: "/api/v2/listar/vehiculos?" + searchParams,
    });
    return response;
  } catch (error) {
    console.error("Error in getTypeVehiclesService:", error);
    throw error;
  }
};
